"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The QuoteResponseLineQuantity model module.
 * @module model/QuoteResponseLineQuantity
 * @version 0.0.1
 */
var QuoteResponseLineQuantity = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>QuoteResponseLineQuantity</code>.
   * @alias module:model/QuoteResponseLineQuantity
   */
  function QuoteResponseLineQuantity() {
    _classCallCheck(this, QuoteResponseLineQuantity);
    QuoteResponseLineQuantity.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(QuoteResponseLineQuantity, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>QuoteResponseLineQuantity</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuoteResponseLineQuantity} obj Optional instance to populate.
     * @return {module:model/QuoteResponseLineQuantity} The populated <code>QuoteResponseLineQuantity</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new QuoteResponseLineQuantity();
        if (data.hasOwnProperty('qty')) {
          obj['qty'] = _ApiClient["default"].convertToType(data['qty'], 'Number');
        }
        if (data.hasOwnProperty('uom')) {
          obj['uom'] = _ApiClient["default"].convertToType(data['uom'], 'String');
        }
        if (data.hasOwnProperty('lead_time')) {
          obj['lead_time'] = _ApiClient["default"].convertToType(data['lead_time'], 'Number');
        }
        if (data.hasOwnProperty('cost')) {
          obj['cost'] = _ApiClient["default"].convertToType(data['cost'], 'Number');
        }
        if (data.hasOwnProperty('condition')) {
          obj['condition'] = _ApiClient["default"].convertToType(data['condition'], 'String');
        }
        if (data.hasOwnProperty('custom_fields')) {
          obj['custom_fields'] = _ApiClient["default"].convertToType(data['custom_fields'], {
            'String': 'String'
          });
        }
        if (data.hasOwnProperty('rfq_line_quantity_id')) {
          obj['rfq_line_quantity_id'] = _ApiClient["default"].convertToType(data['rfq_line_quantity_id'], 'Number');
        }
        if (data.hasOwnProperty('no_quote')) {
          obj['no_quote'] = _ApiClient["default"].convertToType(data['no_quote'], 'Boolean');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} qty
 */
QuoteResponseLineQuantity.prototype['qty'] = undefined;

/**
 * @member {String} uom
 */
QuoteResponseLineQuantity.prototype['uom'] = undefined;

/**
 * @member {Number} lead_time
 */
QuoteResponseLineQuantity.prototype['lead_time'] = undefined;

/**
 * @member {Number} cost
 */
QuoteResponseLineQuantity.prototype['cost'] = undefined;

/**
 * @member {String} condition
 */
QuoteResponseLineQuantity.prototype['condition'] = undefined;

/**
 * @member {Object.<String, String>} custom_fields
 */
QuoteResponseLineQuantity.prototype['custom_fields'] = undefined;

/**
 * @member {Number} rfq_line_quantity_id
 */
QuoteResponseLineQuantity.prototype['rfq_line_quantity_id'] = undefined;

/**
 * @member {Boolean} no_quote
 * @default false
 */
QuoteResponseLineQuantity.prototype['no_quote'] = false;
var _default = exports["default"] = QuoteResponseLineQuantity;